/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-alert */
/* eslint-disable no-param-reassign */
/* eslint-disable import/no-cycle */
import React, { useEffect, useState, useRef } from 'react';
import { DialogUtility, DialogComponent } from '@syncfusion/ej2-react-popups';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import {
  GridComponent,
  Inject,
  ColumnsDirective,
  ColumnDirective,
  Search,
  Page,
  Toolbar,
  Edit,
  Sort,
  Filter,
  ForeignKey,
  Group,
  LazyLoadGroup,
  ExcelExport,
} from '@syncfusion/ej2-react-grids';
import { Link, useNavigate } from 'react-router-dom';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';

import { DataManager, Query } from '@syncfusion/ej2-data';
import { useStateContext } from '../contexts/ContextProvider';
import orgpng from '../data/organization.png';
import { calliopeGrid } from '../data/dummy';
import { Header } from '../components';
import scribeHow from '../data/scribehow.png';

const Calliope = () => {
  const navigate = useNavigate();
  let usr = localStorage.getItem('user');
  let selectedOrg = localStorage.getItem('organization');
  if (!usr || !selectedOrg) {
    // Redirect
    navigate('/login?landing=calliope');
    return <p>Please login... </p>;
  }
  usr = JSON.parse(usr);
  selectedOrg = JSON.parse(selectedOrg);
  const [crudUpdate, setCrudUpdate] = useState(false);
  const [crudCreate, setCrudCreate] = useState(false);
  const [crudDelete, setCrudDelete] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const grid = useRef(null);
  const [data, setData] = useState([]);
  const dialogRef = useRef(null);
  const { REACT_APP_API_ENDPOINT } = process.env;
  const add = { text: 'Add', tooltipText: 'Add Associate', prefixIcon: 'e-plus', id: 'add', visible: crudCreate, disabled: false };
  const myedit = { text: 'Edit', tooltipText: 'Edit Associate', prefixIcon: 'e-edit', id: 'edit', visible: crudUpdate, disabled: false };
  const del = { text: 'Delete', tooltipText: 'Delete Associate', prefixIcon: 'e-delete-2', id: 'delete', visible: crudDelete, disabled: false };
  const excel = { text: 'Excel Export', tooltipText: 'Export', prefixIcon: 'e-export-excel', id: 'excel', disabled: false, visible: true };
  const toolbarOptions = [add, myedit, del, excel, 'Search'];
  const groupOptions = {
    enableLazyLoading: true,
    columns: ['organizationid'],
  };

  // const toolbarOptions = ['Delete', 'Add', 'Edit', 'Search', 'ExcelExport'];
  const { activeMenu, zRenderMode, isMobile } = useStateContext();
  const selectionSettings = { mode: 'Row', type: 'Single' };
  const valuerules = { required: true };
  let myScreenSize = 'auto';

  const refreshDialog = () => {
    dialogRef.current.refresh();
  };

  const fields = [
    { id: 'ns', value: 'Not Specifed' },
    { id: 'battery', value: 'Battery' },
    { id: 'msn', value: 'MSN' },
    { id: 'temperature.reading', value: 'CBT' },
    { id: 'heartrate.reading', value: 'HRM' },
    { id: 'device', value: 'Device' },
    { id: 'name', value: 'Name' },
    { id: 'subject', value: 'Subject' },
    { id: 'log entry', value: 'Log' },
    { id: 'latlng', value: 'Location' },
    { id: 'feelslikemaxtemperature', value: 'Temperature' },
  ];
  const fieldParams = {
    params: {
      actionComplete: () => false,
      dataSource: new DataManager(fields),
      fields: { value: 'id', text: 'value' },
      query: new Query(),
    },
  };
  const collections = [
    { id: 'ns', value: 'Not Specified' },
    { id: 'inventory', value: 'Inventory' },
    { id: 'associates', value: 'Associates' },
    { id: 'device_events', value: 'Device Events' },
    { id: 'calendar_events', value: 'Calendar Events' },
    { id: 'jobs', value: 'Jobs' },
    { id: 'jobKmlLocation', value: 'Job Location' },
  ];
  const collectionParams = {
    params: {
      actionComplete: () => false,
      dataSource: new DataManager(collections),
      fields: { value: 'id', text: 'value' },
      query: new Query(),
    },
  };
  const actions = [
    { id: 'SMS', value: 'SMS' },
    { id: 'Email', value: 'Email' },
    { id: 'Device', value: 'Device audio message' },
    { id: 'Log', value: 'Log only' },
  ];
  const actionParams = {
    params: {
      actionComplete: () => false,
      dataSource: new DataManager(actions),
      fields: { value: 'id', text: 'value' },
      query: new Query(),
    },
  };

  const [activeCommand, setActiveCommand] = useState({});
  const [commandMode, setCommandMode] = useState('add-command');
  const [name, setName] = useState('');
  const [command, setCommand] = useState('');
  const [organizationid, setOrganizationId] = useState('');
  const [organization, setOrganization] = useState('');
  const [hideDialog, setDialog] = useState(true);
  let addField = '';
  let addCollection = '';
  let addAction = '';
  const organizations = {
    params: {
      actionComplete: () => false,
      allowFiltering: true,
      dataSource: data.organization,
      fields: { value: '_id', text: 'title' },
      query: new Query(),
    },
  };

  const addRule = () => {
    const n = document.getElementById('name').value;
    const c = document.getElementById('command').value;
    if (activeCommand && activeCommand.rules && addField.length > 0 && addCollection.length > 0 && addAction.length > 0) {
      const newRule = { field: addField, collection: addCollection, action: addAction };
      const newCommand = activeCommand;
      setName(n);
      setCommand(c);
      activeCommand.name = n;
      activeCommand.command = c;
      newCommand.rules.push(newRule);
      setActiveCommand(newCommand);
      refreshDialog();
    }
  };
  const removeRule = (idx) => {
    if (activeCommand && activeCommand.rules && activeCommand.rules.length - 1 >= idx) {
      const updatedItems = activeCommand.rules.filter((item, index) => index !== idx);
      const newCommand = activeCommand;
      newCommand.rules = updatedItems;
      setActiveCommand(newCommand);
      refreshDialog();
    }
  };

  const saveCommand = () => {
    const saveData = activeCommand;
    data.organization.forEach((org) => {
      if (org._id === organizationid) {
        saveData.organizationid = org._id;
        saveData.organization = org.title;
        setOrganization(org.title);
      }
    });
    saveData.name = name;
    saveData.command = command;
    if (saveData.name.length === 0) {
      DialogUtility.alert('Name required.');
      return;
    }
    if (saveData.command.length === 0) {
      DialogUtility.alert('Command required.');
      return;
    }
    if (organizationid.length === 0) {
      DialogUtility.alert('Organization required.');
      return;
    }
    if (saveData.rules.length === 0) {
      DialogUtility.alert('At least one rule is required.');
      return;
    }
    let method = 'POST';
    if (commandMode === 'edit_command') {
      method = 'UPDATE';
    }
    fetch(`${REACT_APP_API_ENDPOINT}/calliope`, {
      method,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(saveData),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        setDialog(!hideDialog);
        // The added/edited data will be saved in the Grid
        if ((!responseJson || !responseJson.id || responseJson.id.length === 0) && method === 'POST') {
          DialogUtility.alert('Calliope add command failed');
          return;
        }
        if (responseJson && responseJson.response !== 'OK' && method === 'UPDATE') {
          DialogUtility.alert(`Update failed ${responseJson.response}`);
          return;
        }
        if (responseJson && responseJson.id && method === 'POST') {
          saveData.id = responseJson.id;
          const newdata = data;
          newdata.commands.push(saveData);
          setData(newdata);
        }
        DialogUtility.alert(`${method === 'POST' ? 'SST Command Insert succeeded' : 'SST Command Update succeeded'}`);
        setRefresh(!refresh);
      })
      .catch(() => {
        DialogUtility.alert('An error has occured during Insert!');
      });
  };

  const savebuttons = [
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
        saveCommand();
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: true,
        content: 'SAVE',
      },
    },
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
        setDialog(!hideDialog);
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: true,
        content: 'CANCEL',
      },
    },
  ];
  const addbuttons = [
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: true,
        content: 'ADD',
      },
    },
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: true,
        content: 'CANCEL',
      },
    },
  ];
  const header = () => (
    <div><h1>{commandMode === 'add_command' ? 'Add ' : 'Edit '}Calliope Commands/Rules ({organization})</h1></div>
  );
  const profileTemplate = () => (
    <div className="bg-white rounded-3xl">
      <div key="rule_name_command" className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2">
        {activeCommand
        && (
        <div className="">
          <div className="flex zackat-divalh">
            <label className="mb-10" htmlFor="name">Title</label><br />
            <TextBoxComponent id="name" className="mt-4" placeholder="title to give your command" value={activeCommand.name} title="Text Rule Title" floatLabelType="Never" onChange={(e) => { setName(e.value); }} />
            <label className="mb-10" htmlFor="name">Command</label><br />
            <TextBoxComponent id="command" placeholder="this is the command the Associate will say" value={activeCommand.command} title="Supported command" floatLabelType="Never" onChange={(e) => { setCommand(e.value); }} />
          </div>
        </div>
        )}
      </div>
      <div key="rule_existing" className="mt-6 mb-4 row custom-margin zackat-divalh">
        Existing rules:
        {activeCommand.rules.map((item, index) => (
          <div key={`rules_${index}`} className="col-xs-6 col-sm-6 mt-10 col-lg-6 col-md-6">
            <div className="e-input-group">
              <div className="flex">
                <DropDownListComponent
                  id={`field_${index}`}
                  floatLabelType="Auto"
                  cssClass="e-outline"
                  dataSource={fieldParams.params.dataSource}
                  fields={fieldParams.params.fields}
                  placeholder="Select Field"
                  value={item.field}
                  onChange={(v) => { const temp = activeCommand; temp.rules[index].field = v.value; setActiveCommand(temp); if (dialogRef) { dialogRef.current.refresh(); } }}
                />
              </div>
              <div className="flex">
                <DropDownListComponent
                  id={`collection_${index}`}
                  floatLabelType="Auto"
                  cssClass="e-outline"
                  dataSource={collectionParams.params.dataSource}
                  fields={collectionParams.params.fields}
                  placeholder="Select Collection"
                  value={item.collection}
                  onChange={(v) => { const temp = activeCommand; temp.rules[index].collection = v.value; setActiveCommand(temp); if (dialogRef) { dialogRef.current.refresh(); } }}
                />
              </div>
              <div className="flex">
                <DropDownListComponent
                  id={`action_${index}`}
                  floatLabelType="Auto"
                  cssClass="e-outline"
                  dataSource={actionParams.params.dataSource}
                  fields={actionParams.params.fields}
                  placeholder="Select Action"
                  value={item.action}
                  onChange={(v) => { const temp = activeCommand; temp.rules[index].action = v.value; setActiveCommand(temp); if (dialogRef) { dialogRef.current.refresh(); } }}
                />
              </div>
            </div>
            <div className="rightcontainer">
              <ButtonComponent
                cssClass="e-large"
                iconCss="e-icons e-trash"
                onClick={() => { removeRule(index); }}
              >
                Remove Rule
              </ButtonComponent>

            </div>
          </div>
        ))}
      </div>
      <div key="rule_add" className="mt-6 mb-4 row custom-margin zackat-divalh">
        Add new rule:
        { activeCommand && (
        <div className="col-xs-6 col-sm-6 mt-10 col-lg-6 col-md-6">
          <div className="e-input-group">
            <DropDownListComponent
              id="field_add"
              floatLabelType="Auto"
              cssClass="e-outline"
              dataSource={fieldParams.params.dataSource}
              fields={fieldParams.params.fields}
              placeholder="Select Field"
              value=""
              onChange={(v) => { addField = v.value; }}
            />
            <DropDownListComponent
              id="collection_add"
              floatLabelType="Auto"
              cssClass="e-outline"
              dataSource={collectionParams.params.dataSource}
              fields={collectionParams.params.fields}
              placeholder="Select Collection"
              value=""
              onChange={(v) => { addCollection = v.value; }}
            />
            <DropDownListComponent
              id="action_add"
              floatLabelType="Auto"
              cssClass="e-outline"
              dataSource={actionParams.params.dataSource}
              fields={actionParams.params.fields}
              placeholder="Select Action"
              value=""
              onChange={(v) => { addAction = v.value; }}
            />
          </div>
          <div className="rightcontainer">
            <ButtonComponent
              cssClass="e-large"
              iconCss="e-icons e-plus"
              onClick={() => { addRule(); }}
            >
              Add Rule
            </ButtonComponent>
          </div>
        </div>
        )}
      </div>
      <div className="row mt-6 custom-margin">
        Organization
        <div className="col-xs-6 col-sm-6 mt-10 col-lg-6 col-md-6">
          <div className="e-input-group">
            <DropDownListComponent
              id="orgelement"
              floatLabelType="Auto"
              cssClass="e-outline"
              dataSource={organizations.params.dataSource}
              fields={organizations.params.fields}
              placeholder="Select Organization"
              value={organizationid}
              onChange={(v) => { setOrganizationId(v.value); setOrganization(v.target.itemData.title); }}
            />
          </div>
        </div>
      </div>
    </div>
  );
  const {
    screenSize,
    setScreenSize,
  } = useStateContext();

  useEffect(() => {
    const handleResize = () => setScreenSize(window.innerWidth);
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  if (activeMenu === false) {
    myScreenSize = 'auto';
  } else {
    const s = (screenSize - 450).toString();
    myScreenSize = `${s}px`;
  }
  const gridOrgHeader = () => (
    <div className="">
      <img
        className="w-10 h-10"
        src={orgpng}
        alt="organization"
      />
      <pre>Organization</pre>
    </div>
  );

  const [loading, setLoading] = useState(true);
  useEffect(() => {
    // limit associates to the overall selection
    if (selectedOrg && selectedOrg.id && selectedOrg.id.length > 0) {
      usr.organizationid = selectedOrg.id;
    }
    // fetch data
    const dataFetch = async () => {
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/calliope?${query}`;
      const mydata = await (
        await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
        })
      ).json();

      // set state when the data received
      setData(mydata);
      setLoading(false);
    };
    dataFetch();
  }, [refresh]);
  useEffect(() => {
    if (data.role && data.role.alerts) {
      if (data.role.alerts.permissions.includes('Create')) {
        setCrudCreate(true);
      }
      if (data.role.alerts.permissions.includes('Update')) {
        setCrudUpdate(true);
      }
      if (data.role.alerts.permissions.includes('Delete')) {
        setCrudDelete(true);
      }
    }
  }, [data]);

  const actionComplete = (args) => {
    /** Set initial Focus */
    if (args.requestType === 'delete') {
      if (args.data) {
        // Here you can send the updated data to your server using AJAX call
        fetch(`${REACT_APP_API_ENDPOINT}/calliope`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(args.data),
        })
          .then((response) => response.json())
          .then(() => {
            // The added/edited data will be saved in the Grid
            // The default edit operation is cancelled
            setRefresh(!refresh);
          })
          .catch(() => {
            DialogUtility.alert('An error has occured during Delete!');
          });
      }
    }
  };
  const clickHandler = (args) => {
    if (grid && grid.current && args.item.properties.text === 'Excel Export') {
      const properties = {
        fileName: `Calliope_${new Date().toISOString()}.xlsx`,
      };
      grid.current.excelExport(properties);
    } else if (grid && grid.current && args.item.properties.text === 'Delete') {
      const selectedRow = grid.current.getSelectedRecords()[0];
      if (!selectedRow) {
        DialogUtility.alert('Please select a command to Delete!');
        return;
      }
      grid.current.deleteRecord(selectedRow);
    } else if (grid && grid.current && args.item.properties.text === 'Edit') {
      const selectedRecords = grid.current.getSelectedRecords();
      if (!selectedRecords || selectedRecords.length === 0) {
        DialogUtility.alert('Please select a command to Edit!');
        return;
      }
      setActiveCommand(selectedRecords[0]);
      setName(selectedRecords[0].name);
      setCommand(selectedRecords[0].command);
      setOrganizationId(selectedRecords[0].organizationid);
      setOrganization(selectedRecords[0].organization);
      setCommandMode('edit_command');
      setDialog(false);
    } else if (grid && grid.current && args.item.properties.text === 'Add') {
      setName('');
      setCommand('');
      setCommandMode('add_command');
      setActiveCommand({ command: '', name: '', rules: [], organizationid: '', organization: '' });
      setDialog(false);
    }
  };

  if (loading) {
    return <p>Loading... </p>;
  }

  if (!data || !data.role || !data.role.alerts || !data.role.alerts.permissions || !data.role.alerts.permissions.includes('Read')) {
    return <p>Not authorized...</p>;
  }
  const editing = {
    allowEditing: crudUpdate,
    allowAdding: crudCreate,
    allowDeleting: crudDelete,
    showConfirmDialog: true,
    showDeleteConfirmDialog: true,
    allowEditOnDblClick: false,
    mode: 'Dialog',
  };
  const editingMobile = {
    allowEditing: crudUpdate,
    allowAdding: crudCreate,
    allowDeleting: crudDelete,
    showConfirmDialog: true,
    showDeleteConfirmDialog: true,
    allowEditOnDblClick: false,
    mode: 'Normal',
  };
  return (
    <div className="m-2 md:m-10 mt-24 p-2 md:p-10 bg-white rounded-3xl zackat-div">
      <div className="flex">
        <Link
          className="my-link"
          to="https://scribehow.com/viewer/How_to_Set_Up_a_New_or_Existing_Calliope_Rule__B8lv0oitSu-CsiV4mk-yFw"
          target="_blank"
        >
          <img src={scribeHow} width={20} height={20} />
        </Link>
        <Header category="Apps" title="Calliope Commands" />
      </div>
      <div className="e-adaptive-demo e-bigger">
        <div className="e-mobile-layout">
          <div className="e-mobile-content">
            <GridComponent
              dataSource={data.commands}
              width={myScreenSize}
              allowPaging
              allowSorting
              allowExcelExport
              pageSettings={{ pageSize: 20 }}
              editSettings={isMobile ? editingMobile : editing}
              enableStickyHeader
              toolbar={toolbarOptions}
              toolbarClick={clickHandler}
              actionComplete={actionComplete}
              selectionSettings={selectionSettings}
              allowTextWrap
              ref={grid}
              enableAdaptiveUI={isMobile}
              rowRenderingMode={zRenderMode}
              enableAltRow
              allowGrouping
              groupSettings={groupOptions}
              enablePersistence
            >
              <ColumnsDirective>
                {/* eslint-disable-next-line react/jsx-props-no-spreading */}
                {calliopeGrid.map((item, index) => <ColumnDirective key={index} {...item} />)}
                <ColumnDirective
                  field="organizationid"
                  headerText="Organization"
                  width="150"
                  textAlign="Left"
                  editType="dropdownedit"
                  headerTemplate={gridOrgHeader}
                  edit={organizations}
                  visible
                  foreignKeyField="_id"
                  foreignKeyValue="title"
                  validationRules={valuerules}
                  dataSource={organizations.params.dataSource}
                />
              </ColumnsDirective>
              <Inject services={[Search, Page, Toolbar, Edit, Sort, Filter, ForeignKey, Group, LazyLoadGroup, ExcelExport]} />
            </GridComponent>
          </div>
          {!hideDialog && activeCommand && (
          <DialogComponent
            ref={dialogRef}
            header={header}
            content={profileTemplate}
            buttons={activeCommand !== 'add_command' ? savebuttons : addbuttons}
            width="55%"
            height="85%"
            isModal
            visible
            closeOnEscape
            showCloseIcon
            onClose={() => {
              setDialog(!hideDialog);
            }}
            close={() => { setDialog(!hideDialog); }}
          />
          )}
        </div>
      </div>
    </div>
  );
};
export default Calliope;
